// TODO: migrate autocomplete to UI Bootstrap typeahead
(function (module) {
  'use strict';
  module.directive('organizationautocomplete', ['$filter', orgAutoCompleteDir]);

  function orgAutoCompleteDir($filter) {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        // Autohighlight on focus -- optional
        elem.on('focus', function() {
          this.select();
        });

        elem.autocomplete({
          source: function (request, response) {
            //term has the data typed by the user
            var params = request.term;

            if (scope.organizationMap) {
              var result = $filter('filter')(scope.organizationMap, {
                name: params,
              });
              _.map(result, function (item) {
                item['value'] = item['name'];
                item['id'] = item['id'];
              });
            }
            response(result);
          },

          select: function (event, ui) {
            scope.organizationInput = ui.item.id;
            scope.selectedId = ui.item.id;
            scope.selectedName = ui.item.name;
            scope.$apply();
          },

          minLength: 0,
        }).autocomplete('widget').addClass('org-autocomplete');
      },
    };
  }
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/directives/organizationAutoComplete.directive.js